// import Page from "src/components/Page";
// import Header from "./components/Header";
// import MainSection from "./components/MainSection";
// import { Box, Typography } from "@mui/material";
// import { useTheme } from "@mui/material/styles";
// import { useState, useEffect } from "react";

// const Login = () => {
//   const isSubAdmin = localStorage.getItem("isSubAdmin") === "true";
//   const theme = useTheme();

//   // ---------- animation ----------
//   const words = ["EXPAND", "EXPLORE", "ENRICH", "ELEVATE"];
//   const [currentWordIndex, setCurrentWordIndex] = useState(0);
//   useEffect(() => {
//     const id = setInterval(() => setCurrentWordIndex(i => (i + 1) % words.length), 3000);
//     return () => clearInterval(id);
//   }, []);

//   if (isSubAdmin) { /* … */ }

//   const videoUrl =
//     "https://dshtnacfuwriafxvxfuz.supabase.co/storage/v1/object/public/elements/video%201house.mp4";

//   return (
//     <Page
//       title="Login"
//       sx={{
//         height: "100vh",
//         overflow: "hidden",               
//         bgcolor: theme.palette.mode === "dark" ? "#000" : "#fefefe",
//       }}
//     >

//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: { xs: "column", md: "row" },
//           height: "100%",
//         }}
//       >
//         <Box
//           sx={{
//             height: { xs: "15vh", md: "100vh" },  
//             flex: { md: "0 0 55%" },               
//             position: "relative",
//             overflow: "hidden",
//             width: { xs: "100%", md: "auto" },
//           }}
//         >
//           <video autoPlay loop muted playsInline style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover", filter: "grayscale(100%)" }}>
//             <source src={videoUrl} type="video/mp4" />
//           </video>

//           <Box sx={{ position: "absolute", inset: 0, bgcolor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", color: "white" }}>
//             <Typography
//               key={currentWordIndex}
//               variant="h3"
//               sx={{
//                 fontWeight: 700,
//                 fontSize: { xs: "2rem", sm: "3rem", md: "4.5rem", lg: "6rem" },
//                 textShadow: "3px 3px 12px rgba(0,0,0,0.8)",
//                 animation: "fadeInOut 3s ease-in-out",
//                 "@keyframes fadeInOut": {
//                   "0%": { opacity: 0, transform: "translateY(15px)" },
//                   "20%": { opacity: 1, transform: "translateY(0)" },
//                   "80%": { opacity: 1, transform: "translateY(0)" },
//                   "100%": { opacity: 0, transform: "translateY(-15px)" },
//                 },
//               }}
//             >
//               {words[currentWordIndex]}
//             </Typography>
//           </Box>
//         </Box>

//         <Box
//           sx={{
//             height: {
//               xs: "calc(100vh - 15vh)",  
//               md: "calc(100vh - 0px)",  
//             },
//             flex: {
//               md: 1,        
//               lg: 1,          
//               xl: "0 0 45%"   
//             },
//             bgcolor: "#fefefe",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             p: { xs: 2, sm: 18, lg: 1, xl: 10 },
//           }}
//         >
//           <MainSection />
//         </Box>

//       </Box>
//     </Page>
//   );
// };

// export default Login;

import Page from "src/components/Page";
import Header from "src/components/LandingPage/Header";
import LoginHeroSection from "./LoginHeroSection";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useState, useEffect } from "react";
import Footer from "src/components/LandingPage/Footer"


const Login = () => {
  return (
    <div className="h-[100dvh] bg-background flex flex-col overflow-hidden landscape:overflow-y-auto landscape:md:overflow-hidden">
      <Header />
      <main className="flex-1 min-h-0 pt-10 md:pt-11">
        <LoginHeroSection/>
      </main>
      <Footer />
    </div>
  );
};
export default Login;
